<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">Dijital Ehliyet Numarası</label>
            <input class="form-control" :disabled="value.HasDigitalDriverLicenseNumber || !value.HasDriverLicense" v-model="value.DigitalDriverLicenseNumber" type="text" placeholder="Dijital Ehliyet Numarası"/>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object
    }
}
</script>
